import React from 'react';
import { Blockquote, Section, SectionHeader } from 'rebass';

export default function InfoSection() {
  return (
    <Section>
      <SectionHeader heading="What's a spoonerism?" />
      <Blockquote
        href="https://en.wikipedia.org/wiki/Spoonerism"
        mb={4}
        source="Wikipedia">
        A <strong>spoonerism</strong> is an error in speech or deliberate play on words in
        which corresponding consonants, vowels, or morphemes are
        switched... between two words in a phrase. ... It is named after the Reverend William Archibald Spooner (1844–1930),
        ... who was notoriously prone to this mistake.
      </Blockquote>
    </Section>
  );
}



/** WEBPACK FOOTER **
 ** ./src/components/InfoSection.js
 **/